module.exports = __webpack_public_path__ + "static/media/home.9b3a85a9.png";